module.exports = __webpack_public_path__ + "img/Snowflake.9c50b136.png";